import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import "../styles/LegalModal.css";

export default function LegalModal({ open, title, children, onClose }) {
  const closeBtnRef = useRef(null);

  useEffect(() => {
    if (!open) return;

    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    window.addEventListener("keydown", onKeyDown);
    setTimeout(() => closeBtnRef.current?.focus(), 0);

    return () => {
      window.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, onClose]);

  if (!open) return null;

  const handleBackdropMouseDown = (e) => {
    if (e.target === e.currentTarget) onClose?.();
  };

  const modal = (
    <div className="legal-backdrop" onMouseDown={handleBackdropMouseDown}>
      <div className="legal-modal" role="dialog" aria-modal="true" aria-label={title}>
        <div className="legal-header">
          <h3 className="legal-title">{title}</h3>
        </div>

        <div className="legal-body" id="legal-print-area">
          {children}
        </div>

        <div className="legal-footer">
          <button className="legal-btn" onClick={onClose} type="button">
            Close
          </button>
        </div>
      </div>
    </div>
  );

  // 🔥 This is the key line:
  return createPortal(modal, document.body);
}